import { toast } from "react-toastify";
const initialState = {
  loading: false,
  error: null,
  list: null,
};
export default function qr(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "qr/list":
      return { ...state, loading: false, error: null };
    case "qr/update":
      return { ...state, loading: false, error: null };
    case "qr/add":
      return { ...state, loading: false, error: null };
    case "qr/delete":
      return { ...state, loading: false, error: null };
    case "qr/info":
      return {
        ...state,
        loading: false,
        list: data,
        error: null,
      };
    /////////////
    case "qr/loading":
      return { ...state, loading: true };
    case "qr/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };
    default:
      return state;
  }
}
